<div [ngClass]="isSuperAdmin == 'true'? 'spr-admn-mrgn': 'content-blk'">
  <div class="container">
    <h5 class="page-title" *ngIf="(userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId != 0">
      Product Details
      <small class="pull-right title-link">
        <a [routerLink]="['/store/customizedproducts']">Product Library</a>
        <a [routerLink]="['/store/publishedproducts']">See Published</a>
      </small>
      <span class="clearfix"></span>
    </h5>
    <span *ngIf="productAdditionalInfo != null ||  userRole != 'EndUser';"
          class="ribbon-main ribbon-main-{{productAdditionalInfo.ProductType}}">
      {{productAdditionalInfo.ProductType}}
    </span>
    <div class="white-background">
      <div class="row dtl-prdct">
        <div class="col-md-5" [ngClass]="{'discontinuedProduct': !IsActive || !HasActiveColors || !IsAvailable}">
          <div class="prdt-dt-bx">
            <!-- Badge: prefer the chosen decoration name from the detail response (DecorationName);
                 fall back to the product-level shim (DecorationType); default to "Digital". -->
            <span class="dec-type">
              {{selectedDecorationName || productAdditionalInfo.DecorationType || 'Digital'}}
            </span>
            <div class="prdt-dt-nbx">
              <img id="file-image" [src]="imageSrc || 'assets/img/load.gif'" alt="Preview">
            </div>
            <div class="main-pro-bottom-img-bottm prdt-btm-lx dv-cstmzed-prdcdtals">
              <ul>
                <li *ngFor="let img of imageList" (click)="selectProductImage(img.Image)">
                  <div *ngIf="img.IsActive && img.Id>=0">
                    <img src="{{img.Image  || 'assets/img/load.gif'}}" alt="" />

                    <div *ngIf="!IsShopifyProduct && (userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === 1 && sampleOrderForStoreAdmin==='0'">
                      <mat-radio-group aria-label="Select default image" name="DefaultImageRadio"
                                       style=" margin-left: 7px">
                        <mat-radio-button matTooltip="Set Default Image" [value]="img.IsDefault"
                                          *ngIf="IsActive || HasActiveColors" [checked]="img.IsDefault"
                                          (click)="fn_SetDefaultImage(img)"></mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="margin:3px" *ngIf="img.IsActive && img.Id<0">
                    <i style="font-size: 12px; position: absolute; " *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'" class="fa fa-info-circle text-info" title="Size Label" aria-hidden="true"></i>
                    <img style="height:55px;" src="{{img.Image  || 'assets/img/load.gif'}}" alt="" />
                  </div>
                </li>
              </ul>
              <div class="upload-custom-images"
                   *ngIf="!IsShopifyProduct && ((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === 1) && (IsActive && HasActiveColors) && sampleOrderForStoreAdmin==='0'">
                <a (click)="fn_OpenUploadImageModal()" class="mat-btn mat-rst-btn">
                  <i class="fa fa-upload" aria-hidden="true"></i> Upload Custom Images
                </a>
                <br />
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-7">
          <div [ngClass]="{'discontinuedProduct': !IsActive || !HasActiveColors}">
            <div class="dtl-content">
              <div class="dtl-top">
                <div class="rt-ttl-head">
                  <h4>
                    <i style="vertical-align:middle" class="material-icons text-muted"
                       *ngIf="((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && selectedProduct.isWarehouseProduct)" title="Warehouse Product">
                      store_mall_directory
                    </i>
                    <img *ngIf="IsShopifyProduct" src="assets/img/shopify-icon.png" matTooltip="Shopify Product"
                         width="25" />
                    {{selectedProduct.name}}
                    <i *ngIf="((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === 1) && IsActive &&  sampleOrderForStoreAdmin==='0' && !IsShopifyProduct"
                       (click)="openEditTextWindow()" class="fa fa-pencil show-edit"></i>
                    <small *ngIf="!IsActive" class="discontinuedText">&nbsp;&nbsp;***Discontinued</small>
                    <small *ngIf="!IsAvailable" class="discontinuedText">&nbsp;&nbsp;***Out of stocks</small>
                  </h4>
                  <div class="rate-count-in">
                    <bar-rating [(rate)]="rateValue" title="{{rateValue}}" [max]="5"></bar-rating>
                  </div>
                </div>
              </div>

              <div class="product-detail">
                <h5>
                  Description:
                  <i *ngIf="(userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === 1 &&  sampleOrderForStoreAdmin==='0' && !IsShopifyProduct"
                     (click)="openEditTextWindow()" class="fa fa-pencil show-edit"></i>
                  <small [innerHTML]="selectedProduct.longDescription"></small>
                </h5>
              </div>
              <div class="row">
                <div style="display: flex;" class="col-md-12">
                  <div *ngFor="let item of productLabels; index as i">
                    <div *ngIf="item.text" class="badge" class="dv-lbls"
                         [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}">
                      <span>{{item.text}}</span>
                    </div>
                  </div>
                  <div *ngIf="productLabels[0].text && isSuperAdmin == 'true'" class="col-md-3" style="margin-top: 4px;">
                    <span class="spn-icn-edit" (click)="openEditTextWindow()"><i class="fa fa-edit"></i>&nbsp;Edit Label</span>
                  </div>
                  <div *ngIf="!productLabels[0].text && isSuperAdmin == 'true'" class="col-md-3" style="margin-top: 4px;">
                    <span class="spn-icn-edit" (click)="openEditTextWindow()"><i class="fa fa-plus"></i>&nbsp;Add Label</span>
                  </div>
                </div>

              </div>

              <ng-container *ngIf="productAdditionalInfo">
                <div class="product-detail">
                  <h5>
                    Made in:
                    <small>{{productAdditionalInfo.MadeIn}}</small>
                  </h5>
                </div>
                <div class="product-detail">
                  <h5>
                    Composition:
                    <small>{{productAdditionalInfo.Composition}}</small>
                  </h5>
                </div>
              </ng-container>

              <div class="product-detail dv-sze-lst dv-cstmsed-prdct-dtls-size">
                <h5>Size</h5>
                <mat-button-toggle-group  name="sizes" aria-label="Sizes"
                [hideSingleSelectionIndicator]="true" class="prdc-dtls-ul">
                  <ul class="sz-lst-ul ">
                    <ng-container *ngIf="selectedProduct.isWarehouseProduct">
                      <li *ngFor="let size of currentWarehouseSizeList">
                        <mat-button-toggle [value]="size.SizeId"
                                          (click)="size.IsAvailable && fn_SelectWarehouseSize(size.SizeId)"
                                          [checked]="size.SizeId == cartProduct.sizeId"
                                          [ngClass]="{'disabledColor' : !size.IsAvailable}"
                                          [matTooltip]="!size.IsAvailable ? size.SizeName + ' size is not available right now' : null">
                          {{size.SizeName}}
                        </mat-button-toggle>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="!selectedProduct.isWarehouseProduct">
                      <li *ngFor="let size of currentSizeName">
                        <ng-container *ngIf="!IsShopifyProduct">
                          <mat-button-toggle [value]="size.SizeId" (click)="fn_SelectSize(size.SizeId)"
                                            [checked]="size.SizeId == cartProduct.sizeId">
                            {{size.Name}}
                          </mat-button-toggle>
                          <br>
                          <small *ngIf="!loading" class="sml-qty"> Qty: {{size.AvailableQty == null || size.AvailableQty == 0 ? 'NA' : size.AvailableQty}} </small>
                          <small *ngIf="loading" class="sml-qty"> Qty: loading.. </small>
                        </ng-container>
                        <ng-container *ngIf="IsShopifyProduct">
                          <mat-button-toggle [value]="size.SizeId" (click)="fn_SelectSizeShopify(size.SizeId)"
                                            [checked]="size.SizeId == cartProduct.sizeId">
                            {{size.Name}}
                          </mat-button-toggle>
                          <br>
                          <small *ngIf="!loading" class="sml-qty"> Qty: {{size.AvailableQty == null || size.AvailableQty == 0 ? 'NA' : size.AvailableQty}} </small>
                          <small *ngIf="loading" class="sml-qty"> Qty: loading.. </small>
                        </ng-container>
                      </li>
                    </ng-container>
                  </ul>
                </mat-button-toggle-group>
              </div>

              <div class="product-detail dv-cstmsed-prdct-dtls">
                <h5 style="margin-top: 5px;">
                  Color
                  <small class="color-name"
                         *ngIf="cartProduct && cartProduct.colorName">{{cartProduct.colorName}}</small>
                </h5>
                <mat-button-toggle-group name="color" aria-label="Color"
                [hideSingleSelectionIndicator]="false">
                  <ul class="sz-lst-ul tick prdc-dtls-ul">
                    <ng-container *ngIf="selectedProduct.isWarehouseProduct">
                      <li *ngFor="let color of warehouseColorList" matTooltip="{{color.ColorName}}">
                        <mat-button-toggle [value]="color.StyleId" [ngStyle]="displayColor(color.HexCode)"
                                          [checked]="color.IsDefault" (click)="color.IsAvailable && selectWarehouseStyle(color.StyleId)"
                                          *ngIf="color.IsActive" [ngClass]="{'disabledColor' : !color.IsAvailable}"
                                          [matTooltip]="!color.IsAvailable ? color.ColorName + ' color is not available right now' : color.ColorName">
                        </mat-button-toggle>
                        <mat-button-toggle title="{{color.ColorName}} ***Discontinued" [value]="color.StyleId"
                                          [ngStyle]="displayColor(color.HexCode)" class="discontinuedColor" *ngIf="!color.IsActive">
                        </mat-button-toggle>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="!selectedProduct.isWarehouseProduct">
                      <li *ngFor="let color of colorList" matTooltip="{{color.colorName}}">
                        <ng-container *ngIf="!IsShopifyProduct">
                          <mat-button-toggle title="{{color.colorName}}" [value]="color.uniqueStyleId"
                                            [ngStyle]="displayColor(color.colorCode)" [checked]="color.IsDefault"
                                            (click)="selectStyle(color.uniqueStyleId)" *ngIf="color.IsActive">
                          </mat-button-toggle>
                        </ng-container>
                        <ng-container *ngIf="IsShopifyProduct">
                          <mat-button-toggle title="{{color.colorName}}" [value]="color.uniqueStyleId"
                                            [ngStyle]="displayColor(color.colorCode)" [checked]="color.IsDefault"
                                            (click)="selectStyleShopify(color.uniqueStyleId)" *ngIf="color.IsActive">
                          </mat-button-toggle>
                        </ng-container>
                        <mat-button-toggle title="{{color.colorName}} ***Discontinued" [value]="color.uniqueStyleId"
                                          [ngStyle]="displayColor(color.colorCode)" class="discontinuedColor" *ngIf="!color.IsActive">
                        </mat-button-toggle>
                      </li>
                    </ng-container>
                  </ul>
                </mat-button-toggle-group>
              </div>

              <!-- Decoration selector (WI-1378): shown only for EndUser when product offers >1 decoration. -->
              <div class="product-detail dv-cstmsed-prdct-dtls" *ngIf="showDecorationSelector">
                <h5>Decoration</h5>
                <mat-button-toggle-group name="decoration" aria-label="Decoration"
                  [hideSingleSelectionIndicator]="true">
                  <ul class="sz-lst-ul prdc-dtls-ul">
                    <li *ngFor="let decoration of decorations">
                      <mat-button-toggle
                        [value]="decoration.DecorationTypeId"
                        [checked]="selectedDecoration && selectedDecoration.DecorationTypeId === decoration.DecorationTypeId"
                        (click)="selectDecoration(decoration)">
                        {{decoration.Name}}
                      </mat-button-toggle>
                    </li>
                  </ul>
                </mat-button-toggle-group>
              </div>
              <!-- End decoration selector -->

              <div class="product-detail"
                   *ngIf="userRole === null || userRole === 'EndUser' || sampleOrderForStoreAdmin==='1' ">
                <h5>Quantity</h5>
                <div class="mt-qti-bk">
                  <button mat-icon-button (click)="fn_DecrementQty()">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <span style="margin-top: 12px;">{{cartProduct.quantity}}</span>
                  <button mat-icon-button (click)="fn_IncrementQty()">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>

              <div class="product-detail">
                <h5>
                  <label *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">Retail</label> Price :
                  <strong>
                    {{selectedProduct.productFinalCost | currency:'USD':'symbol':'1.2-2' }}
                    <small style="font-size:12px;">per piece</small>
                  </strong>
                  <br />
                  <small style="font-size: 12px;" class="text-muted"
                         *ngIf="userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">
                    <span *ngIf="selectedProduct.retailPrice >0 && sampleOrderForStoreAdmin=='0'" style="padding-left:0px;">
                      Profit margin : {{selectedProduct.retailPrice | currency:'USD':'symbol':'1.2-2'}}
                      <br />
                    </span>
                    <span *ngIf="selectedProduct.finishingPrice > 0" style="padding-left:0px;">
                      Finishing Price : {{selectedProduct.finishingPrice | currency:'USD':'symbol':'1.2-2'}}
                    </span><br *ngIf="EmbroideryCost > 0" />
                    <span *ngIf="EmbroideryCost > 0" style="padding-left:0px;">
                      Embroidery Cost : {{EmbroideryCost | currency:'USD':'symbol':'1.2-2'}}

                    </span>
                    <br *ngIf="!selectedProduct.isWarehouseProduct && selectedProduct.discountPercent != null && selectedProduct.discountPercent > 0" />
                    <span *ngIf="!selectedProduct.isWarehouseProduct && selectedProduct.discountPercent != null && selectedProduct.discountPercent > 0">
                      <h6 style="padding:0px!important" *ngIf="!IsEmbroideryType">
                        Your additional profit for discount on product :
                        {{(selectedProduct.unitCost + selectedProduct.finishingPrice+ (selectedProduct.printingCost *(noOfCustomizedSides - 1))) * selectedProduct.discountPercent / 100 | currency:'USD':'symbol':'1.2-2'}}
                      </h6>
                      <h6 style="padding:0px!important" *ngIf="IsEmbroideryType">
                        Your additional profit for discount on product :
                        {{(selectedProduct.unitCost + selectedProduct.finishingPrice + (EmbroideryCost *(noOfCustomizedSides - 1))) * selectedProduct.discountPercent / 100 | currency:'USD':'symbol':'1.2-2'}}
                      </h6><br *ngIf="EmbroiderySetUpCost > 0 && IsEmbroideryType" />
                      <span *ngIf="EmbroiderySetUpCost > 0 && IsEmbroideryType" style="padding-left:0px;">
                        One time {{ EmbroiderySetUpCost |currency:'USD':'symbol':'1.0-2'}} per side will be charged on
                        first order as a Embroidery setup fees. Order will not be fulfilled incase of failed payments
                        for Embroidery setup cost.
                      </span>
                      <br *ngIf="EmbroiderySetUpCost > 0 && IsEmbroideryType" />
                    </span>
                  </small>

                </h5>

                <h5 *ngIf="selectedProduct.ExpectedShipDate != null">
                  Expected ship date : <small class="smll-expshpdate"> {{selectedProduct.ExpectedShipDate}}</small>
                </h5>
              </div>
              <div class="row">
                <div style="display: flex;" class="col-md-12">
                  <div *ngFor="let item of productTags; index as i">
                    <div *ngIf="item.tagtext" class="badge" class="dv-tags">
                      <span>{{item.tagtext}}</span>
                    </div>
                  </div>
                  <div *ngIf="productTags[0].tagtext && isSuperAdmin == 'true'" class="col-md-3" style="margin-top: 4px;">
                    <span class="spn-icn-edit" (click)="openEditTextWindow()"><i class="fa fa-edit"></i>&nbsp;Edit Tag</span>
                  </div>
                  <div *ngIf="!productTags[0].tagtext  && isSuperAdmin == 'true'" class="col-md-3" style="margin-top: 4px;">
                    <span class="spn-icn-edit" (click)="openEditTextWindow()"><i class="fa fa-plus"></i>&nbsp;Add Tag</span>
                  </div>
                </div>
              </div>

              <!-- Decoration Type Changed Warning -->
              <div *ngIf="isDecorationTypeChanged && isSuperAdmin == 'true'" class="row">
                <div class="col-md-12">
                  <div class="decoration-type-warning">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span>Decoration type is changed. Do you want to change tag also? </span>
                    <a class="update-tag-link" (click)="openEditTextWindow()">Yes</a>
                  </div>
                </div>
              </div>

              <div class="dtl-ftr" *ngIf="IsActive && HasActiveColors">
                <!-- INKSOFT DISABLED (2026-09): store-admin InkSoft customize retired; product creation/editing uses Design Huddle -->
                <a class="adwscart" *ngIf="false" (click)="fn_CustomizeProduct()">Customize</a>
              </div>
            </div>
          
            <div *ngIf="isSuperAdmin == 'false'">
              <div class="dtl-ftrb"
                   *ngIf="(( (userRole === null||sampleOrderForStoreAdmin==null) || userRole === 'EndUser') || ((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && sampleOrderForStoreAdmin==='1')) && (IsActive && HasActiveColors && IsAvailable)">
                <a class="mat-btn" style="cursor: pointer; color: white !important;" (click)="fn_AddToCart()">
                  Add to Cart
                </a>
                <a *ngIf="false" class="mat-btn"
                   style="cursor: pointer;" (click)="fn_CustomizeProduct()">Customize</a>
              </div>
            </div>
            <div class="dtl-ftr" *ngIf="((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === 1) && sampleOrderForStoreAdmin=='0'">
              <ng-container *ngIf="IsActive && HasActiveColors">
                <ng-container *ngIf="!IsShopifyProduct">
                  <a (click)="fn_OpenPublishModal(cartProduct.customizedProductId,productId,designId)"
                     class="mat-btn mat-rst-btn" style="cursor: pointer;">
                    Publish
                  </a>
                </ng-container>

                <a (click)="editProduct()" *ngIf="sizingLabelGenerated" class="mat-btn mat-rst-btn"
                   style="cursor: pointer;">Redesign</a>
              </ng-container>

              <ng-container *ngIf="IsActive">
                <ng-container *ngTemplateOutlet="rmpTemplate"></ng-container>
              </ng-container>
            </div>

            <div class="dtl-ftr" *ngIf="!HasActiveColors" style="font-size: 20px; font-weight: 600; color: #b5afaf;">
              ***Currently no colors are available
            </div>
          </div>

          <ng-container *ngIf="!IsActive">
            <div class="dtl-ftr" *ngIf="((userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') && typeId === '1') && sampleOrderForStoreAdmin=='0'"
                 style="margin-top: 25px;">
              <ng-container *ngTemplateOutlet="rmpTemplate"></ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>


    <app-product-detail-review [productId]="productId" [rateValue]="rateValue"></app-product-detail-review>
  </div>
</div>


<ng-template #rmpTemplate>
  <a (click)="fn_replaceProduct()" class="btn-yllw" style="cursor: pointer;"
     matTooltip="Change the master product(Specially if the product is discontinued)">
    Replace Master Product
  </a>
</ng-template>
